import {
    RETRIEVE_PRODUCT_GROUPS,
    CREATE_PRODUCT_GROUPS,
    UPDATE_PRODUCT_GROUPS
} from "../../actions/types";

const initialState = [];

function productGroupReducer(productGroup = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case RETRIEVE_PRODUCT_GROUPS:
            return payload;
        case CREATE_PRODUCT_GROUPS:
            return [...productGroup, payload];
        case UPDATE_PRODUCT_GROUPS:
            return productGroup.map((group) => {
                if (group.product_group_id === payload.product_group_id) {
                    return {
                        ...group,
                        ...payload
                    };
                } else {
                    return group;
                }
            })
        default:
            return productGroup;
    }
}

export default productGroupReducer;